// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileMenu_wrapper__P8CSa","link":"ProfileMenu_link__xczXx","linkText":"ProfileMenu_linkText__nGGoe","arrow":"ProfileMenu_arrow__EuEzD"};